module.exports = __webpack_public_path__ + "img/home.d7910dea.png";